

import React, { memo } from 'react';
import { Text } from '../../../../../ui-kit';
import BadgeStatus from './BadgeStatus';







const AddonsFinalCost = ({ className = '', subtotal, paymentStatus }) => {
  const renderBadge = () => {
    switch (paymentStatus) {
      case 'SUCCEEDED':
        return <BadgeStatus type="PRIMARY" labelText="Paid" />;
      case 'REFUNDED':
        return <BadgeStatus type="SECONDARY" labelText="Refunded" />;
      default:
        return null;
    }
  };

  return (
    <div className={className}>
      {renderBadge()}
      <Text className="outputs-and-addons__addons-final-cost__total">
        {`Total Add-ons: ${subtotal}`}
      </Text>
    </div>);

};

export default memo(AddonsFinalCost);